import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import { DATE_FORMAT_CUSTOMER, DATE_FORMAT_ISO, DATE_FORMAT_MONTH_DAY } from '../constants';

const configureDateService = () => {
  dayjs.extend(minMax);
};

const formatCustomerDate = (dateStr) => {
  const dateObj = dayjs(dateStr);
  return dateObj.format(DATE_FORMAT_CUSTOMER);
};

const formatIsoDate = (dateStr) => {
  const dateObj = dayjs(dateStr);
  return dateObj.format(DATE_FORMAT_ISO);
};

const formatMonthDayDate = (dateStr) => {
  const dateObj = dayjs(dateStr);
  return dateObj.format(DATE_FORMAT_MONTH_DAY);
};

/* Formats a string in the format HH:MM and returns it like "H:MM PM / AM" */
const formatTime = (timeStr) => {
  const match = timeStr.match(/(?<hour>\d{2}):(?<minutes>\d{2})/);
  if (!match) {
    return timeStr; // Pattern is unknown, keep the original format
  }
  const { hour, minutes } = match.groups;
  return dayjs().startOf('day').hour(hour).minute(minutes)
    .format('h:mm A');
};

const daysBetween = (start, end) => dayjs(end).diff(dayjs(start), 'day');

export {
  daysBetween,
  configureDateService,
  formatCustomerDate,
  formatIsoDate,
  formatMonthDayDate,
  formatTime,
};
